'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/is-hotkey/lib/index.js');
var index_es = require('../node_modules/slate-react/dist/index.es.js');
var useTextEditor = require('./useTextEditor.js');
var utils = require('./utils.js');
var Element = require('./Element.js');
var Leaf = require('./Leaf.js');
var styles = require('./styles.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+shift+x': 'strikeThrough'
};
var Input = _ref => {
  var {
    minHeight,
    maxHeight
  } = _ref;
  var {
    readOnly,
    setIsFocused
  } = useTextEditor.useTextEditor();
  var messageClasses = styles.useMessageStyles({
    minHeight,
    maxHeight
  });
  var editor = index_es.useSlate();
  var renderElement = React__namespace.useCallback(props => /*#__PURE__*/React__namespace.createElement(Element.Element, props), []);
  var renderLeaf = React__namespace.useCallback(props => /*#__PURE__*/React__namespace.createElement(Leaf.Leaf, props), []);
  var messageRef = React__namespace.useRef();
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: messageClasses.message,
    onClick: () => index_es.ReactEditor.focus(editor),
    onKeyPress: () => index_es.ReactEditor.focus(editor),
    role: "textbox",
    tabIndex: 0,
    ref: messageRef
  }, /*#__PURE__*/React__namespace.createElement(index_es.Editable, {
    readOnly: readOnly,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    spellCheck: true,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    onKeyDown: event => {
      var _selection$getBoundin, _messageRef$current$c, _messageRef$current, _messageRef$current$s, _messageRef$current2;

      // The psuedo-input created by slate-js does not automatically
      // scroll to the cursor position when it goes below the message
      // window boundy.
      var selection = window.getSelection().getRangeAt(0); // Capture the bounding rect for the cursor selection.

      var {
        bottom = 0
      } = (_selection$getBoundin = selection === null || selection === void 0 ? void 0 : selection.getBoundingClientRect()) !== null && _selection$getBoundin !== void 0 ? _selection$getBoundin : {}; // This is the height of the visible window (possibly bounded by
      // minHeight and maxHeight in props)

      var clientHeight = (_messageRef$current$c = (_messageRef$current = messageRef.current) === null || _messageRef$current === void 0 ? void 0 : _messageRef$current.clientHeight) !== null && _messageRef$current$c !== void 0 ? _messageRef$current$c : 0; // This is the position of the scroll container

      var scrollTop = (_messageRef$current$s = (_messageRef$current2 = messageRef.current) === null || _messageRef$current2 === void 0 ? void 0 : _messageRef$current2.scrollTop) !== null && _messageRef$current$s !== void 0 ? _messageRef$current$s : 0; // The selections bottom is relative to the visible window. If this
      // delta is greater than the clientHeight then we are outside the
      // visible window. This captures how far below the visible window
      // we are.

      var scrollDelta = Math.max(0, bottom - clientHeight);

      if (scrollDelta) {
        var _messageRef$current3;

        (_messageRef$current3 = messageRef.current) === null || _messageRef$current3 === void 0 ? void 0 : _messageRef$current3.scroll(0, scrollTop + scrollDelta);
      }

      for (var hotkey in HOTKEYS) {
        if (index['default'](hotkey, event)) {
          event.preventDefault();
          var mark = HOTKEYS[hotkey];
          utils.toggleMark(editor, mark);
        }
      }
    }
  }));
};

exports.Input = Input;
